export default __webpack_public_path__ + "static/media/search.7a023fe8.png";